// extracted by css-extract-rspack-plugin
export default {"status":"status-iUWyF_","tooltip":"tooltip-hSGHYa"};